export default function() {
    if (!window.FC) {
        var FC = FC || {};
        window.FC = FC;
    }
    if (!window.TRACKING) {
        var TRACKING = TRACKING || {};
        window.TRACKING = TRACKING;
    }
}